import styled from 'styled-components';
import { tokens, media } from '../../../../../design/tokens';

export const Container = styled.article`
  width: 60%;
  min-height: fit-content;

  margin: auto;

  top: 7rem;

  border-radius: ${tokens.radius.sm};
  background-color: ${tokens.color.cardCharcoal};
  box-shadow: ${tokens.shadow.imageSeat};

  position: relative;

  ${media.upTo(tokens.breakpoint.md)} {
    width: 80%;
  }
`;

export const CloseModalButton = styled.button`
  position: absolute;
  right: 10px;
  top: 6px;
  background-color: transparent;
  border: none;

  &:hover {
    border: none;
    cursor: pointer;
  }
`;

interface IRow {
  paddingTop?: number;
}

export const Row = styled.div<IRow>`
  display: flex;
  align-items: center;
  margin: auto;
  flex-direction: column;

  padding: ${({ paddingTop }) => paddingTop ?? 80}px;

  width: 80%;

  color: ${tokens.color.textWhite};
  font-family: ${tokens.font.body.family};

  > p {
    text-align: center;
  }

  > svg {
    font-size: 5rem;
    color: ${tokens.color.errorRed};
    margin-bottom: ${tokens.space.lg};
  }

  ${media.upTo(tokens.breakpoint.xs)} {
    padding-top: 80px;
    flex-direction: column;
  }
`;

export const HeaderContainer = styled.figure``;

export const Title = styled.h2`
  position: absolute;

  color: ${tokens.color.textWhite};

  top: 1.5rem;
  left: 38%;
  text-align: center;

  font-family: ${tokens.font.heading.family};

  ${media.upTo(tokens.breakpoint.xs)} {
    font-size: 1.2rem;
    left: 18%;
    max-width: 200px;
  }
`;
